import styled from 'styled-components/macro';

const Line = styled.div`
  height: 11px;
  width: 1px;
  margin: -1px 5px 0;
  background-color: #fff;
  opacity: 0.7;
`;

export default Line;
